export const PENDING_STATE = 'PENDING';
export const SUCCESS_STATE = 'SUCCESS';
export const ERROR_STATE = 'ERROR';
